import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export default makeStyles(
  (theme) => ({
    root: {},
    bluish: {},

    input: {
      width: '100%',
      padding: 0,
      alignSelf: 'flex-start',

      fontSize: theme.typography.pxToRem(14),

      transition: theme.transitions.create('width', {
        duration: theme.transitions.duration.short,
      }),

      '$bluish &': {
        backgroundColor: '#F5F7FB',
      },
    },
    outline: {
      border: theme.shape.borderGray60,
      borderRadius: theme.shape.borderRadius,

      '$bluish &': {
        border: 'none',
      },
    },
    iconSearch: {
      fontSize: theme.typography.pxToRem(16),
      color: COLORS.neutral.mediumGray,
      marginLeft: 10,
    },
    iconClear: {
      fontSize: theme.typography.pxToRem(14),
    },
  }),
  { name: 'SearchField' }
);
